import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ExportOrdersRequest } from '@classes/order/export-orders-request';

@Component({
  selector: 'app-select-orders-export-type',
  templateUrl: './select-orders-export-type.component.html',
  styleUrls: ['./select-orders-export-type.component.scss'],
})
export class SelectOrdersExportTypeComponent implements OnInit {
  @Input() title: string = '';
  @Input() iconName: string = '';
  @Input() disabled: boolean = false;

  @Output() onExportTypeSelected: EventEmitter<ExportOrdersRequest> =
    new EventEmitter<ExportOrdersRequest>();

  public exportTypeForm = this._fb.group({
    excel: [false],
    consignmentNote: [false],
    photos: [false],
    documents: [false],
    roadmap: [false],
    all: [false],
  });

  constructor(private _fb: FormBuilder) {}

  public ngOnInit(): void {
    this._subscribeToAllControlChanges();
  }

  private _subscribeToAllControlChanges(): void {
    this.exportTypeForm.get('all').valueChanges.subscribe((value: boolean) => {
      this._turnAllType(value);
    });
  }

  private _turnAllType(value: boolean): void {
    Object.keys(this.exportTypeForm.controls).forEach((key: string) => {
      this.exportTypeForm.get(key).setValue(value, { emitEvent: false });
    });
  }

  public canExport(): boolean {
    //Check if at least one type is selected except all
    return Object.keys(this.exportTypeForm.controls).some((key: string) => {
      return this.exportTypeForm.get(key).value === true && key !== 'all';
    });
  }

  public onExportClicked(): void {
    const exportOrderRequest: ExportOrdersRequest =
      this._buildExportOrderRequest();
    this.onExportTypeSelected.next(exportOrderRequest);
  }

  private _buildExportOrderRequest(): ExportOrdersRequest {
    const exportOrderRequest: ExportOrdersRequest = new ExportOrdersRequest();
    exportOrderRequest.exportExcel = this.exportTypeForm.get('excel').value;
    exportOrderRequest.exportConsignmentNote =
      this.exportTypeForm.get('consignmentNote').value;
    exportOrderRequest.exportPhoto = this.exportTypeForm.get('photos').value;
    exportOrderRequest.exportDocument =
      this.exportTypeForm.get('documents').value;
    exportOrderRequest.exportRoadMap = this.exportTypeForm.get('roadmap').value;
    return exportOrderRequest;
  }
}
